import ReactDOM from "react-dom";

export default function VideoModal({ videoData, onClose }) {
  if (!videoData) return null;

  return ReactDOM.createPortal(
    <div className="video-modal">
      <button className="close-btn" onClick={onClose}>✕</button>
      <iframe
        src={`https://player.vdocipher.com/v2/?otp=${videoData.otp}&playbackInfo=${videoData.playbackInfo}`}
        allowfullscreen="true"
        allow="encrypted-media"
        title="Video Player"
      />
    </div>,
    document.body   // ⬅️ mount directly under <body>
  );
}